import { openDialog } from "../../app-dialog/utils/core/dialogManager.js";
import { hasPermission, getUserId, getTeamId } from "../../../../app/auth.js";

import { filterInitialized, isUpdatingFilters } from "./tableBuilder.js";
import { updateFilterOptions } from "../utils/filterManager.js";

export function attachDefaultEvents(table, {
    updatePermission,
    dialogName = "edit",
    ownUpdate = null,
    ownUpdateField = "userId",
    teamUpdate = null,
    updateSummary = false,
    columnVisibility = null,
    onFilterChange = null,
    onDateFilterChange = null
} = {}) {
    let dataEverLoaded = false;

    table.on("dataFiltered", (filters, rows) => {
        if (!filterInitialized || isUpdatingFilters) return;
        updateFilterOptions(rows.map(r => r.getData()), table);

        if (updateSummary && dataEverLoaded) {
            document.querySelector("app-summary")?.updateStats(rows.map(r => r.getData()));
        }
    });

    if (updateSummary) {
        table.on("dataLoaded", (data) => {
            if (!data.length) return;
            dataEverLoaded = true;
            document.querySelector("app-summary")?.updateStats(data);
        });

        const refreshSummary = () => {
            if (!dataEverLoaded) return;
            const rows = table.getRows("active").map(r => r.getData());
            document.querySelector("app-summary")?.updateStats(rows);
        };

        table.on("rowAdded", refreshSummary);
        table.on("rowUpdated", refreshSummary);
        table.on("rowDeleted", refreshSummary);
    }

    table.on("rowDblClick", (e, row) => {
        const data = row.getData();
        const canEdit = !data.isFactored && (
            hasPermission(updatePermission)
            || (ownUpdate && data[ownUpdateField] == getUserId() && hasPermission(ownUpdate))
            || (teamUpdate && data.teamId == getTeamId() && hasPermission(teamUpdate))
        );
        if (canEdit) openDialog(dialogName, data);
    });

    if (columnVisibility) {
        table.on("tableBuilt", () => {
            const savedFilter = sessionStorage.getItem(columnVisibility.sessionKey) || "user";
            applyColumnVisibility(table, savedFilter, columnVisibility.employeeField, columnVisibility.teamField);
        });
    }

    const filter = document.querySelector("app-filter");
    if (columnVisibility || onFilterChange) {
        filter?.addEventListener("filter-change", e => {
            if (columnVisibility) {
                applyColumnVisibility(table, e.detail.value, columnVisibility.employeeField, columnVisibility.teamField);
            }
            onFilterChange?.(e.detail.value);
        });
    }
    if (onDateFilterChange) {
        filter?.addEventListener("date-filter-change", onDateFilterChange);
    }
}

function applyColumnVisibility(table, filterValue, employeeField, teamField) {
    table.blockRedraw();

    if (filterValue !== "user") {
        table.showColumn(employeeField);
    } else {
        table.hideColumn(employeeField);
        table.setHeaderFilterValue(employeeField, "");
    }

    if (filterValue === "all") {
        table.showColumn(teamField);
    } else {
        table.hideColumn(teamField);
        table.setHeaderFilterValue(teamField, "");
    }

    table.restoreRedraw();
    table.redraw(true);
}